import { render, staticRenderFns } from "./OrthoPlayStages.vue?vue&type=template&id=482a66c4&"
import script from "./OrthoPlayStages.vue?vue&type=script&lang=js&"
export * from "./OrthoPlayStages.vue?vue&type=script&lang=js&"
import style0 from "./OrthoPlayStages.vue?vue&type=style&index=0&id=482a66c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports